// extracted by mini-css-extract-plugin
module.exports = {"videoPlayer":"VideoPlayer_videoPlayer__2ftxF","container":"VideoPlayer_container__4o0MB"};